import React from 'react';
import { withTranslation } from './ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomModal from './Modal';

const BannerPreview = ({isVisible, url, width, height, title, onClose, t = {} }) => {
    if (!url) {
        return null;
    }

    const staticNames = (t?.offersPage && t.offersPage.offer) ? t.offersPage.offer : {};

    return (
        <CustomModal
            visible={isVisible}
            onClose={onClose}
            title={staticNames.preview || ""}
            areNoControls={true}
            className={'modal-responsive modal-banner'}
        >
            <div className="banner-preview">
                <div className="banner-preview__wrapp">
                    <div className="banner-preview__axis banner-preview__axis_y">
                        <div className="banner-preview__size">{height}px</div>
                    </div>
                    <div className="banner-preview__axis banner-preview__axis_x">
                        <div className="banner-preview__size">{width}px</div>
                    </div>
                    <img className="banner-preview__image" src={url} alt={title} />
                </div>
            </div>
        </CustomModal>
    )
};

BannerPreview.propTypes = {
    isVisible: PropTypes.bool,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    title: PropTypes.string,
    onClose: PropTypes.func,
    t: PropTypes.object
};

BannerPreview.defaultProps = {
    isVisible: false,
    url: '',
    width: 0,
    height: 0,
    title: '',
    onClose: () => {},
    t: {}
};

export default withTranslation(BannerPreview);
